import { DEFAULT_API_CONFIG } from './apiConfig';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/assignmentImport`;

// returns { fileName, fileData (base64 xlsx with Result/Reason columns), totalRows, succeeded, failed }
export const submitAssignmentImport = async file => {
  let headers = getHeaders();
  delete headers['Content-Type'];

  const formData = new FormData();
  formData.append('file', file);

  const response = await fetch(baseRoute, {
    method: 'POST',
    body: formData,
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};
